import React from 'react';
import {connect} from "react-redux";
import {Avatar, Paper, Subheader} from "material-ui";
import gravatar from 'gravatar';
import Loading from "../../../components/common/Loading/Loading";
import AdminForm from "../../../components/admin/AdminForm/AdminForm";
import styles from './EditProfilePage.css';
import style from '../../../styles/styles';
import {editAdmin} from '../../../store/auth/actions';
import {PROFILE_PAGE} from "../../../constants/routes";

export class EditProfilePage extends React.Component {

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            this.props.history.push(PROFILE_PAGE);
        }
    }

    handleFormSubmit = async (formProps) => {
       await this.props.editAdmin(formProps);
    };

    render() {
        if (this.props.loading || !this.props.user || this.props.sending) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Account / Edit</h3>
                    <Avatar src={gravatar.url(this.props.user.email)}
                            size={75}
                            style={styles.avatar}/>
                    <Paper style={styles.editBox}>
                        <Subheader style={style.subHeader}>My profile</Subheader>
                        <div style={style.paper}>
                            <AdminForm
                                onSubmit={this.handleFormSubmit}
                                initialValues={this.props.initialValue}
                                submitting={this.props.sending}
                            />
                        </div>
                        <div style={style.clear}/>
                    </Paper>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.auth.loading,
        sending: state.auth.sending,
        authenticated: state.auth.authenticated,
        user: state.auth.content,
        initialValue: state.auth.content
    }
}

export default connect(mapStateToProps, {editAdmin})(EditProfilePage);



// WEBPACK FOOTER //
// src/containers/common/EditProfilePage/EditProfilePage.js